import './Balance.scss';
import React, { useState } from 'react';
import SurveyComponent from '../Survey/Survey';
import ChartComponent from '../Chart/Chart'; // Your Chart.js component

const BalanceComponent = ({ data }) => {
  const [showChart, setShowChart] = useState(false);
  const [surveyData, setSurveyData] = useState();

  const handleSurveyComplete = (data) => {
      setSurveyData(data);
      onFinalComplete();
  };

  const onFinalComplete = () => {
    setShowChart(true);
  };

  return (
    <div>
      {!showChart ? <SurveyComponent onCompleteSurvey={handleSurveyComplete} /> : <ChartComponent data={[surveyData, data]} />}
      
    </div>
  );
};

export default BalanceComponent;
